(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pltrs-collector-welcome"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('.pltrs-welcome a[href^="#collector-delivery-"]');
  if (!link) return;
  const details = document.getElementById(link.getAttribute('href').slice(1));
  if (details) details.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pltrs-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pltrs-slider')) {
  customElements.define('pltrs-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.controls = this.querySelector('.pltrs-slider__controls');
      if (!this.track || !this.previous || !this.next) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const update = () => {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);
        this.controls.hidden = maximum < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= maximum - 2;
      };
      const move = (direction) => {
        const first = this.track.firstElementChild;
        if (!first) return;
        const style = getComputedStyle(this.track);
        const step = first.getBoundingClientRect().width + parseFloat(style.columnGap || 0);
        const sign = style.direction === 'rtl' ? -1 : 1;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollBy({ left: direction * step * sign, behavior });
      };
      this.previous.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }
        if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth * (rtl ? -1 : 1), behavior: 'auto' });
        }
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      requestAnimationFrame(update);
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pltrs-new-this-week"]) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-pltrs-new-week]').forEach((dialog) => {
        if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
        dialog.dataset.initialized = 'true';
        const forced = new URLSearchParams(window.location.search).get('pltrs_new') === '1' || Boolean(window.Shopify && window.Shopify.designMode);
        const expires = Date.parse(dialog.dataset.expires || '');
        if (!forced && window.matchMedia('(max-width: 749px)').matches) return;
        if (!forced && Number.isFinite(expires) && Date.now() >= expires) return;
        const key = 'pltrs-new-week:' + dialog.dataset.campaign;
        const readSeen = () => {
          try { return Number(window.localStorage.getItem(key) || 0); }
          catch (error) { try { return Number(window.sessionStorage.getItem(key) || 0); } catch (error) { return 0; } }
        };
        const remember = () => {
          if (forced) return;
          const value = String(Date.now());
          try { window.localStorage.setItem(key, value); }
          catch (error) { try { window.sessionStorage.setItem(key, value); } catch (error) {} }
        };
        const cooldown = Number(dialog.dataset.hideHours || 168) * 3600000;
        if (!forced && Date.now() - readSeen() < cooldown) return;
        let priorOverflow = '';
        let previousFocus = null;
        let attempts = 0;
        const open = () => {
          if (!dialog.isConnected || dialog.open) return;
          if (!forced && document.visibilityState === 'hidden') {
            window.setTimeout(open, 2000);
            return;
          }
          const otherDialog = document.querySelector('dialog[open]');
          const cookieBanner = document.querySelector('#shopify-pc__banner');
          if ((otherDialog && otherDialog !== dialog) || (cookieBanner && cookieBanner.getClientRects().length)) {
            if (++attempts < 20) window.setTimeout(open, 2000);
            return;
          }
          previousFocus = document.activeElement;
          priorOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          remember();
        };
        dialog.querySelectorAll('[data-nw-close]').forEach((button) => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = priorOverflow;
          if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
        });
        window.setTimeout(open, forced ? 300 : Math.max(0, Number(dialog.dataset.delay || 8000)));
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
